import { render, staticRenderFns } from "./FacilityUserReport.vue?vue&type=template&id=4bc16592"
import script from "./FacilityUserReport.vue?vue&type=script&lang=js"
export * from "./FacilityUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports